export default {
    name: 'France power consumption',
    data: {
        "id": "62acd761-f490-4862-98eb-20a476b6557b",
        "type": "Single",
        "title": "France power",
        "config": {
            "type_id": "power_consumption",
            "area_id": 926,
            "hour": "12",
            "start_date": "2025-06-26",
            "end_date": "2025-08-25"
        }
    }
}